// keep in sync with prefix in ./vars.scss#$dsCssVarPrefix
export const DS_CSS_VAR_DEFAULT_POSTFIX = 'default';
